import { render, staticRenderFns } from "./addPrize.vue?vue&type=template&id=43c26fd8&scoped=true&"
import script from "./addPrize.vue?vue&type=script&lang=js&"
export * from "./addPrize.vue?vue&type=script&lang=js&"
import style0 from "./addPrize.vue?vue&type=style&index=0&id=43c26fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c26fd8",
  null
  
)

export default component.exports